import { useState } from 'react'
import { toast } from 'sonner'

import { useSendBrokerNote } from '@/models/broker'

/**
 * Open state, draft and send for a broker note. Held by the always-mounted trigger, so a draft
 * survives Radix unmounting the popover or sheet, and a send that lands after a close still toasts.
 */
export function useBrokerNote(brokerName: string) {
  const firstName = brokerName.split(' ')[0]
  const [open, setOpen] = useState(false)
  const [draft, setDraft] = useState('')
  const mutation = useSendBrokerNote()

  function onOpenChange(next: boolean) {
    setOpen(next)
    if (next && mutation.isError) mutation.reset()
  }

  function send() {
    const content = draft.trim()
    if (!content || mutation.isPending) return
    mutation.mutate(content, {
      onSuccess: () => {
        toast.success(`Note sent to ${firstName}`)
        setDraft('')
        setOpen(false)
      },
    })
  }

  return {
    firstName,
    open,
    onOpenChange,
    draft,
    setDraft,
    send,
    isPending: mutation.isPending,
    isError: mutation.isError,
  }
}
